module.exports = __webpack_public_path__ + "img/PremiumTopPictureOfferSmartBlending.29ef980c.png";